[
  {
    "growth":2411.0,
    "skill":"AI Agent",
    "display_name":"AI Agent"
  },
  {
    "growth":317.0,
    "skill":"n8n",
    "display_name":"n8n"
  },
  {
    "growth":170.0,
    "skill":"Retrieval-Augmented Generation",
    "display_name":"RAG"
  },
  {
    "growth":68.0,
    "skill":"LLM",
    "display_name":"LLM"
  },
  {
    "growth":66.0,
    "skill":"Supabase",
    "display_name":"Supabase"
  },
  {
    "growth":59.0,
    "skill":"artificial intelligence",
    "display_name":"AI"
  },
  {
    "growth":54.0,
    "skill":"Langchain",
    "display_name":"Langchain"
  },
  {
    "growth":27.0,
    "skill":"OpenAI",
    "display_name":"OpenAI"
  },
  {
    "growth":21.0,
    "skill":"MLOps",
    "display_name":"MLOps"
  },
  {
    "growth":21.0,
    "skill":"Make",
    "display_name":"Make"
  }
]
